import { Component } from 'react';

export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 20, color: '#fff', background: '#1a1a2e', textAlign: 'center' }}>
          <h3>Something went wrong</h3>
          <p style={{ color: '#aaa', fontSize: 14 }}>{this.state.error.message}</p>
          <button
            style={{ marginTop: 12, padding: '8px 16px', borderRadius: 6, border: 'none', background: '#e94560', color: '#fff', cursor: 'pointer' }}
            onClick={() => this.setState({ error: null })}
          >
            Try Again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
